import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivateRoutes from "./routes/privateRoutes";
import PublicRoutes from "./routes/publicRoutes";
import login from "./pages/auth/login";
import dashboard from "./pages/dashboard";
import createBadge from "./pages/badge/createBadge";
import badges from "./pages/badge/badges";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <>
      <ToastContainer position="top-right" autoClose={4000} />
      <Router>
        <Routes>
          <Route path="/" element={<PublicRoutes element={login} />} />
          <Route path="/dashboard" element={<PrivateRoutes element={dashboard} />} />
          <Route path="/badges" element={<PrivateRoutes element={badges} />} />
          <Route path="/badges/create" element={<PrivateRoutes element={createBadge} />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
